import type { PermLevel } from "@/lib/api/members";

export function canRead(perms: Record<string, PermLevel>, resource: string): boolean {
  const level = perms[resource] ?? "none";
  return level === "read" || level === "write";
}

export function canWrite(perms: Record<string, PermLevel>, resource: string): boolean {
  return (perms[resource] ?? "none") === "write";
}

/**
 * Hide nav items whose resource the current role cannot read.
 * `perms === undefined` (still loading) shows everything to avoid a menu flash.
 */
export function filterNavByPermissions<T extends { resource?: string }>(
  items: T[],
  perms: Record<string, PermLevel> | undefined
): T[] {
  if (!perms) return items;
  return items.filter((item) => !item.resource || canRead(perms, item.resource));
}
